module.exports = __webpack_public_path__ + "static/media/apple-play-badge.b6bc50e8.png";